import * as Schema from "effect/Schema";

export const ActivityAudience = Schema.Literals(["user", "developer"]);
export type ActivityAudience = typeof ActivityAudience.Type;

export const ActivityLabelText = Schema.Struct({
  ru: Schema.String,
  en: Schema.optionalKey(Schema.String),
});
export type ActivityLabelText = typeof ActivityLabelText.Type;

/** Built-in extractors: the only way a value travels from a raw field into the public label. */
export const ActivityParamExtract = Schema.Literals([
  "parsed_document_name",
  "user_file_name",
  "text",
]);
export type ActivityParamExtract = typeof ActivityParamExtract.Type;

export const ActivityParamRule = Schema.Struct({
  /** `command`, `path`, `query` or `arguments.<key>`. */
  from: Schema.String,
  extract: Schema.optionalKey(ActivityParamExtract),
  maxLength: Schema.optionalKey(Schema.Number),
});
export type ActivityParamRule = typeof ActivityParamRule.Type;

export const ActivityLabelMatch = Schema.Struct({
  itemType: Schema.String,
  /** Tested against the command with the `bash -lc` wrapper, `cd …` and env prefixes removed. */
  command: Schema.optionalKey(Schema.String),
  server: Schema.optionalKey(Schema.String),
  tool: Schema.optionalKey(Schema.String),
  path: Schema.optionalKey(Schema.String),
});
export type ActivityLabelMatch = typeof ActivityLabelMatch.Type;

export const ActivityLabelRule = Schema.Struct({
  id: Schema.String,
  match: ActivityLabelMatch,
  text: ActivityLabelText,
  params: Schema.optionalKey(Schema.Record(Schema.String, ActivityParamRule)),
  audience: Schema.optionalKey(ActivityAudience),
  heartbeat: Schema.optionalKey(Schema.Literal("waiting_helpers")),
});
export type ActivityLabelRule = typeof ActivityLabelRule.Type;

export const ActivityLabelPolicy = Schema.Struct({
  version: Schema.Literal(1),
  rules: Schema.Array(ActivityLabelRule),
  fallback: Schema.Record(Schema.String, ActivityLabelText),
});
export type ActivityLabelPolicy = typeof ActivityLabelPolicy.Type;

export const PublicActivity = Schema.Struct({
  itemType: Schema.String,
  label: Schema.Struct({
    key: Schema.String,
    text: ActivityLabelText,
  }),
  params: Schema.Record(Schema.String, Schema.String),
  audience: ActivityAudience,
  heartbeat: Schema.optionalKey(Schema.Literal("waiting_helpers")),
  unmatched: Schema.Boolean,
  startedAt: Schema.optionalKey(Schema.String),
});
export type PublicActivity = typeof PublicActivity.Type;
